import React from 'react'

import { buildingControllers } from '../../core/controllers/BuildingControllers'

export default class BuildingInsights extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            avgTemp: buildingControllers.currentAvgTemp
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => this.buildingInsights(), 5000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentWillUpdate(nextProps, nextState) {
    }

    buildingInsights() {
        buildingControllers.determineAvgTemp();
        this.setState({avgTemp: buildingControllers.currentAvgTemp});
    }

    render(){
        const avgTemp = this.state.avgTemp;
        return (
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"><i class="icon-icons8-pressure"></i><small><i class="pe-7s-angle-right"></i></small> Building Insight</h4>
                        <p class="category">Powerful insight</p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <hr></hr>
                            <div class="col-md-8">
                                <div class="legend">
                                    <h4>
                                    <i class={"icon-temperature-fancy text-info"}></i> Avg Temp: {avgTemp}&#8457;
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Building/BuildingInsights.jsx